const COMPONENTS = {
  TRUSTED_PAYMENTS: {
    SLUG: 'trusted-payments',
  },
  APP_FOOTER: {
    SLUG: 'app-footer',
  },
  PHONE_NUMBER: {
    SLUG: 'phone-number',
  },
  CREATE_ACCOUNT_PROMO: {
    SLUG: 'create-account-promo',
  },
  CREATE_ACCOUNT_INFO: {
    SLUG: 'create-account-info',
  },
  NOTIFICATION_BANNER: {
    SLUG: 'notification-banner',
  },
  PROMO_BANNERS: {
    SLUG: 'promo-banners',
  },
  SHOP_BY_DEPARTMENT: {
    SLUG: 'shop-by-department',
  },
  TRUSTED_BRANDS: {
    SLUG: 'trusted-brands',
  },
  CAMPAIGN_BANNER: {
    SLUG: 'campaign-banner',
  },
  CAMPAIGN_TITLE: {
    SLUG: 'campaign-title',
  },
  BASIC_PAGE_NAVIGATION: {
    SLUG: 'basic-page-navigation',
  },
};
const PAGE_DELIVERY_KEYS = {
  HOME: {
    SLUG: 'home',
  },
  LANDER: {
    SLUG: 'lander',
  },
};
const CMS_PAGE_LABELS = {
  PREMIUM_GUARANTEE: 'premium-guarantee',
};
const INTERNAL_CMS_TYPE = {
  COMPONENTS: 'components',
  PAGES: 'pages',
};
const INTERNAL_CMS_BASE_PATH = '/public/cms-schemas/';
const INTERNAL_CMS_COMPONENTS_PATH = `${INTERNAL_CMS_BASE_PATH}components/`;
const INTERNAL_CMS_PAGES_PATH = `${INTERNAL_CMS_BASE_PATH}pages/published/`;
const PRODUCT_GROUPS_SLIDER = {
  MIN_ITEMS: 3,
  SLIDER_GAP: 16,
  MAX_VISIBLE_ITEMS: 6,
  MOBILE_IMAGE_HEIGHT: 100,
  CAROUSEL_ITEM_WIDTH: '225px',
};
// TODO - unify exports style
export { COMPONENTS };
export { PAGE_DELIVERY_KEYS };
export { CMS_PAGE_LABELS };
export { INTERNAL_CMS_COMPONENTS_PATH };
export { INTERNAL_CMS_PAGES_PATH };
export { PRODUCT_GROUPS_SLIDER };
export { INTERNAL_CMS_TYPE };
